module.exports = __webpack_public_path__ + "media/images/monthly10-68d651bb78d9afcb852a59a220150a8f.jpg";